export const SHORT_STALE_TIME = 10 * 1000; // 10 seconds
export const MEDIUM_STALE_TIME = 60 * 1000; // 1 minute
export const LONG_STALE_TIME = 5 * 60 * 1000; // 5 minutes
